import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import cx from "clsx";
import { withRouter } from "react-router";
import InsightsSideBar from "../InsightsSideBar.js";
import ReputationTitle from "./ReputationTitle.js";
import ReputationReportTitle from "./ReputationReportTitle.js";
import ReputationReportOptions from "./ReputationReportOptions.js";
import Loader from "../../Common/Loader.js";
import { autoScrolling } from "../../../Utils/services.js";
import {
  resetReducerAction,
  getOptionAndList,
  saveReport,
  getReportVariables,
  getReportData,
  downloadReportData,
  downloadSurveyData,
} from "../../../Actions/BusinessInsights/businessInsightActions.js";
import SaveReport from "../SaveReport.js";
import { uiNotification } from "../../../services/UINotificationService.js";
import { AppTranslation } from "../../../i18n/useAppTranslation.js";
import styles from "./styles/ReputationInsightReport.module.scss";

const COL_NAMES = {
  bi_client_name: "Clinic Name",
  bi_appointment_details: "Appointment Details",
  bi_survey_name: "Survey Name",
  bi_submitted_date: "Submitted Date",
  bi_satisfaction_score: "Satisfaction Score",
};

class ReputationInsightReport extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    this.state = {
      showLoader: false,
      globalLang: languageData.global,
      businessInsightLang: languageData.business_insights,
      showCreateOptions: false,
      type: "reputation-management",
      report_type_sysname: "",
      report_type_id: "",
      reportOptionAndList: {},
      reportOptions: props.reportOptions ? props.reportOptions : [],
      reportVariableData: [],
      reportData: {},

      languageData: languageData.business_insights,
      page: 1,
      pagesize: 15,
      startFresh: true,
      next_page_url: "",
      showLoadingText: false,
      tableColumns: [],
      reportListData: [],
      totalRow: null,
      grammar: null,
      graphData: [],
      sortby: "",
      sortorder: "desc",

      reportType: this.props.match.params.reportType
        ? this.props.match.params.reportType
        : "create",
      reportID: this.props.match.params.reportID
        ? this.props.match.params.reportID
        : 0,
      isBreadcrumbs:
        this.props.match.params && this.props.match.params.reportID > 0
          ? false
          : true,
      insightID:
        this.props.match.params && this.props.match.params.insightID > 0
          ? this.props.match.params.insightID
          : 0,

      showTableSection: false,
      dataLoadedOnce: false,
      showNameSection: false,
      reportNameClass: "simpleInput",

      downloadData: {},
    };

    window.onscroll = () => {
      const scrollTop = parseInt(
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop,
        ),
      );

      if (
        document.documentElement.offsetHeight -
          (window.innerHeight + scrollTop) <=
          5 &&
        this.state.next_page_url != null &&
        this.state.report_type_sysname ===
          "patients-who-gave-the-rate-of-x-or-below"
      ) {
        this.loadMore();
      }
    };
  }

  componentDidMount() {
    autoScrolling(true);
    this.setState({ showLoader: true });

    let reportOptionFilter = {};

    if (
      this.state.reportType === "view" &&
      this.state.reportID &&
      this.state.insightID
    ) {
      this.setState({
        dataLoadedOnce: true,
        selected_report_type_id: this.state.insightID,
      });

      reportOptionFilter.page = this.state.page;
      reportOptionFilter.pagesize = this.state.pagesize;
      reportOptionFilter.business_insight_reports_id = this.state.reportID;
      this.props.getReportData(this.state.insightID, reportOptionFilter);
    } else {
      if (this.state.reportType === "edit" && this.state.reportID > 0) {
        reportOptionFilter.business_insight_reports_id = this.state.reportID;
      }
      this.props.getOptionAndList(this.state.type, reportOptionFilter);
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};
    if (
      nextProps.reportData !== undefined &&
      nextProps.reportData !== prevState.reportData &&
      nextProps.reportData.next_page_url !== prevState.next_page_url
    ) {
      returnState.reportData = nextProps.reportData;
      returnState.tableColumns = nextProps.reportData.columns
        ? nextProps.reportData.columns
        : prevState.tableColumns;
      if (prevState.next_page_url === null) {
        autoScrolling(false);
        return (returnState.next_page_url = null);
      }

      if (
        prevState.reportListData &&
        prevState.reportListData.length === 0 &&
        prevState.startFresh === true
      ) {
        returnState.insightReportData = nextProps.reportData;

        if (nextProps.reportData.next_page_url !== null) {
          returnState.page = prevState.page + 1;
        } else {
          returnState.next_page_url = nextProps.reportData.next_page_url;
        }
        returnState.startFresh = false;
        returnState.showLoader = false;
        returnState.showLoadingText = false;
        returnState.reportListData = nextProps.reportData.data
          ? nextProps.reportData.data
          : [];
        returnState.showTableSection = true;
        returnState.dataLoadedOnce = true;
        returnState.totalRow = nextProps.reportData.total
          ? nextProps.reportData.total
          : 0;
        returnState.grammar = nextProps.reportData.grammar
          ? nextProps.reportData.grammar
          : "";
        returnState.report_type_sysname = nextProps.reportData.sys_name
          ? nextProps.reportData.sys_name
          : prevState.report_type_sysname;
      } else if (
        prevState.insightReportData !== nextProps.reportData &&
        prevState.insightReportData.length !== 0
      ) {
        returnState.reportListData = [
          ...prevState.reportListData,
          ...nextProps.reportData.data,
        ];
        returnState.insightReportData = nextProps.reportData;
        returnState.next_page_url = nextProps.reportData.next_page_url;
        returnState.showLoader = false;
        returnState.page = prevState.page + 1;
        returnState.showLoadingText = false;
      }
      if (prevState.selected_report_type_id == 11) {
        returnState.graphData = returnState.reportListData;
        returnState.next_page_url = null;
      }
      autoScrolling(false);
    } else if (
      nextProps.reportOptionAndList !== undefined &&
      nextProps.reportOptionAndList !== prevState.reportOptionAndList
    ) {
      returnState.reportOptionAndList = nextProps.reportOptionAndList;
      returnState.reportOptions = nextProps.reportOptionAndList.reportOptions;
      returnState.allData = nextProps.reportOptionAndList.allData;
      returnState.showLoader = false;
      if (
        prevState.reportType !== "view" &&
        prevState.showCreateOptions === false &&
        prevState.dataLoadedOnce === false
      ) {
        returnState.showCreateOptions = true;
      }
    } else if (
      nextProps.reportVariableData &&
      nextProps.reportVariableData !== prevState.reportVariableData
    ) {
      returnState.reportVariableData = nextProps.reportVariableData;
      returnState.showLoader = false;
    } else if (
      nextProps.downloadData !== undefined &&
      nextProps.downloadData !== prevState.downloadData
    ) {
      returnState.showLoader = false;
      returnState.downloadData = nextProps.downloadData;
      nextProps.resetReducerAction();
      window.open(
        process.env.REACT_APP_API_URL +
          "download-data/" +
          nextProps.downloadData.file,
        "_blank",
      );
    } else if (
      nextProps.redirect !== undefined &&
      nextProps.redirect === true
    ) {
      nextProps.resetReducerAction();
      uiNotification.success(nextProps.message);
      nextProps.history.push(`/business-insight/${prevState.type}`);
    } else if (
      nextProps.showLoader !== undefined &&
      nextProps.showLoader === false
    ) {
      returnState.showLoader = false;
      nextProps.resetReducerAction();
    }

    return returnState;
  }

  componentDidUpdate = (_, prevState) => {
    if (
      this.state.reportSavedData !== null &&
      this.state.reportSavedData !== "" &&
      this.state.reportSavedData !== prevState.reportSavedData &&
      this.state.savedStatus !== null &&
      this.state.savedStatus !== ""
    ) {
      uiNotification.clear();
      uiNotification.success(this.state.globalLang[this.state.savedStatus]);

      return (
        <div>
          {this.props.history.push(`/business-insight/${this.state.type}`)}
        </div>
      );
    }
  };

  loadMore = () => {
    if (!autoScrolling()) {
      let reportOptionFilter = {};

      if (
        this.state.reportType === "view" &&
        this.state.reportID &&
        this.state.insightID
      ) {
        reportOptionFilter.business_insight_reports_id = this.state.reportID;
        reportOptionFilter.page = this.state.page;
        reportOptionFilter.pagesize = this.state.pagesize;
        reportOptionFilter.sort_order = this.state.sortorder;
        reportOptionFilter.order_by = this.state.sortby;
        this.setState({ showLoadingText: true, startFresh: false });
        this.props.getReportData(this.state.insightID, reportOptionFilter);
      } else {
        reportOptionFilter = this.state.reportFilter;
        reportOptionFilter.page = this.state.page;
        reportOptionFilter.pagesize = this.state.pagesize;
        reportOptionFilter.sort_order = this.state.sortorder;
        reportOptionFilter.order_by = this.state.sortby;

        if (reportOptionFilter) {
          this.setState({ showLoadingText: true, startFresh: false });
          autoScrolling(true);
          this.props.getReportData(
            reportOptionFilter.report_type_id,
            reportOptionFilter,
          );
        }
      }
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({ [event.target.name]: value, dataChanged: true });
  };

  showCreateOptions = (reportType) => {
    if (reportType === "create") {
      return (
        <div>
          {this.props.history.push(
            `/business-insight/${this.state.type}/${reportType}`,
          )}
        </div>
      );
    } else {
      this.setState({ showCreateOptions: true });
    }
  };

  hideCreateOptions = (childSate) => {
    if (this.state.dataLoadedOnce === false) {
      return (
        <div>
          {this.props.history.push(`/business-insight/${this.state.type}`)}
        </div>
      );
    } else {
      this.setState(childSate);
    }
  };

  getData = (childSate) => {
    autoScrolling(true);
    this.setState(childSate);

    let formData = childSate.reportFilter;
    formData.page = 1;
    formData.pagesize = this.state.pagesize;
    this.setState(
      {
        reportListData: [],
        showLoader: true,
        page: 1,
        startFresh: true,
        next_page_url: "",
        selected_report_type_id: childSate.report_type_id,
        selected_report_type_sysname: childSate.report_type_sysname,
        totalRow: null,
        grammar: null,
      },
      () => {
        this.props.getReportData(childSate.report_type_id, formData);
      },
    );
  };

  getReportVariables = (childSate, isVariableData) => {
    this.setState(childSate);
    if (isVariableData) {
      this.props.getReportVariables(childSate.report_type_id);
    }
  };

  downloadData = () => {
    if (this.state.report_type_sysname === "all-surveys") {
      const reportData = this.state.reportData || {};
      this.setState({ showLoader: true });
      return this.props
        .downloadSurveyData({
          clinic_id:
            reportData.clinic_ids?.length === 1
              ? reportData.clinic_ids[0]
              : "0",
          from_date: this.state.reportData?.from_date,
          to_date: this.state.reportData?.to_date,
        })
        .then((res) => {
          window.location.href = res?.data?.file;
        })
        .catch(() => {
          uiNotification.error(
            "Failed to download survey data. Try again later",
          );
        })
        .finally(() => {
          this.setState({ showLoader: false });
        });
    } else {
      let reportOptionFilter = {};
      if (
        this.state.reportType === "view" &&
        this.state.reportID &&
        this.state.insightID
      ) {
        reportOptionFilter.business_insight_reports_id = this.state.reportID;
        reportOptionFilter.is_download = 1;
        this.setState({ showLoader: true });

        this.props.downloadReportData(this.state.insightID, reportOptionFilter);
      } else {
        reportOptionFilter = this.state.reportFilter;
        reportOptionFilter.is_download = 1;
        this.setState({ showLoader: true });

        this.props.downloadReportData(
          reportOptionFilter.report_type_id,
          reportOptionFilter,
        );
      }
    }
  };

  getReportName = () => {
    this.setState({ showNameSection: true });
  };

  hideNameSection = (childState) => {
    this.setState(childState);
  };

  saveThisReport = () => {
    let reportName = this.state.reportName;
    if (this.state.grammar === undefined || this.state.grammar === null) {
      uiNotification.clear();
      uiNotification.error("Grammar is missing");
      return false;
    }

    if (reportName && reportName.trim() !== "") {
      this.setState({
        showLoader: true,
        reportNameClass: "simpleInput",
        reportName: "",
        showNameSection: false,
      });

      let reportFilter = this.state.reportFilter;
      reportFilter.business_insight_id = this.state.reportFilter.report_type_id;
      reportFilter.name = reportName;
      reportFilter.grammar = this.state.grammar;

      if (
        this.state.reportID &&
        this.state.reportID > 0 &&
        this.state.reportType === "edit"
      ) {
        reportFilter.business_insight_report_id = this.state.reportID;
      }
      this.props.saveReport(this.state.type, reportFilter);
    } else {
      this.setState({ reportNameClass: "simpleInput field-error" });
      return;
    }
  };

  handleChildState = (childState) => {
    this.setState(childState);
  };

  onSort = (sortby) => {
    if (sortby === "bi_date") {
      return;
    }

    let sortorder = this.state.sortorder === "asc" ? "desc" : "asc";
    let formData = this.state.reportFilter;
    formData.page = 1;
    formData.pagesize = this.state.pagesize;
    formData.sort_order = sortorder;
    formData.order_by = sortby;

    this.setState(
      {
        reportListData: [],
        showLoader: true,
        page: 1,
        startFresh: true,
        next_page_url: "",
        selected_report_type_id: this.state.report_type_id,
        selected_report_type_sysname: this.state.report_type_sysname,
        sortby: sortby,
        sortorder: sortorder,
      },
      () => {
        this.props.getReportData(this.state.report_type_id, formData);
      },
    );
  };

  render() {
    return (
      <div id="content">
        <SaveReport
          showNameSection={this.state.showNameSection}
          hideNameSection={this.hideNameSection}
          reportNameClass={this.state.reportNameClass}
          saveThisReport={this.saveThisReport}
          reportName={this.state.reportName}
          handleChildState={this.handleChildState}
          reportMode={this.state.reportType}
          editReportID={this.state.reportID}
          propReportType={this.state.reportType}
        />

        <ReputationReportOptions
          showCreateOptions={this.state.showCreateOptions}
          getData={this.getData}
          hideCreateOptions={this.hideCreateOptions}
          getReportVariables={this.getReportVariables}
          reportOptions={this.state.reportOptions}
          reportVariableData={this.state.reportVariableData}
          type={this.state.type}
          reportID={this.state.reportID}
          allData={this.state.allData}
          businessInsightLang={this.state.businessInsightLang}
          globalLang={this.state.globalLang}
          history={this.props.history}
        />

        <div className="container-fluid content setting-wrapper">
          <InsightsSideBar />

          <div className="memberWalletOuter business-section">
            <ReputationTitle
              history={this.props.history}
              isCreateButton={this.state.reportType === "view" ? true : false}
              isBreadcrumbs={this.state.isBreadcrumbs}
              showCreateOptions={this.showCreateOptions}
              businessInsightLang={this.state.businessInsightLang}
              globalLang={this.state.globalLang}
            />

            <div
              className={
                this.state.dataLoadedOnce
                  ? "setting-setion m-b-10"
                  : "setting-setion m-b-10 no-display"
              }
            >
              <ReputationReportTitle
                downloadData={this.downloadData}
                showCreateOptions={this.showCreateOptions}
                saveReport={this.getReportName}
                parentState={this.state}
                showSatisfactionTip={
                  this.state.report_type_sysname ===
                  "percentage-surveys-returned"
                }
              />
              <div className="table-responsive clients-table no-border">
                <table className="table-updated  table-min-width no-td-border no-hover">
                  <thead className="table-updated-thead">
                    {this.state.report_type_sysname ===
                      "patients-who-gave-the-rate-of-x-or-below" && (
                      <tr>
                        {this.state.tableColumns &&
                          this.state.tableColumns.length > 0 &&
                          this.state.tableColumns.map((tobj, tidx) => {
                            let className = "table-updated-th sorting sortData";
                            let dataSort = tobj;
                            let dataOrder = "DESC";

                            if (tobj === "bi_date") {
                              className = "table-updated-th";
                              dataSort = "no-sort";
                              dataOrder = "no-sort";
                            }

                            return (
                              <th
                                key={tidx}
                                className={className}
                                onClick={() => this.onSort(tobj)}
                                data-sort={dataSort}
                                data-order={dataOrder}
                              >
                                {tobj === "bi_client_name" ? (
                                  <AppTranslation.Common path="label.patientName" />
                                ) : (
                                  this.state.languageData[tobj]
                                )}{" "}
                                <i
                                  className={
                                    this.state.sortorder === "asc" &&
                                    this.state.sortby === tobj
                                      ? "blue-gray"
                                      : this.state.sortorder === "desc" &&
                                        this.state.sortby === tobj
                                      ? "gray-blue"
                                      : "gray-gray"
                                  }
                                />
                              </th>
                            );
                          })}
                      </tr>
                    )}
                    {[
                      "nps-score-per-provider",
                      "nps-score-per-clinic",
                      "nps-score-per-service",
                      "all-surveys",
                    ].includes(this.state.report_type_sysname) && (
                      <tr>
                        {this.state.tableColumns?.map((tobj, tidx) => (
                          <th key={tidx} className="table-updated-th">
                            {this.state.languageData[tobj] || COL_NAMES[tobj]}{" "}
                          </th>
                        ))}
                      </tr>
                    )}
                  </thead>
                  <tbody className="ajax_body">
                    {this.state.report_type_sysname !==
                      "nps-score-per-provider" &&
                      this.state.report_type_sysname !==
                        "nps-score-per-service" &&
                      this.state.report_type_sysname !==
                        "percentage-surveys-returned" &&
                      this.state.reportListData &&
                      this.state.reportListData.length > 0 &&
                      this.state.reportListData.map((robj, ridx) => (
                        <tr
                          key={ridx}
                          className={cx("table-updated-tr", {
                            [styles.clickableRow]:
                              this.state.report_type_sysname === "all-surveys",
                          })}
                          onClick={() => {
                            if (
                              this.state.report_type_sysname === "all-surveys"
                            ) {
                              this.props.history.push(
                                `/business-insight/surveys/view/0/${robj.patient_survey_id}/survey-data`,
                              );
                            }
                          }}
                        >
                          {this.state.tableColumns &&
                            this.state.tableColumns.length > 0 &&
                            this.state.tableColumns.map((tobj, tidx) => (
                              <td
                                key={ridx + `_` + tidx}
                                className={"table-updated-td"}
                              >
                                {robj[tobj]}
                              </td>
                            ))}
                        </tr>
                      ))}
                    {(this.state.report_type_sysname ===
                      "nps-score-per-provider" ||
                      this.state.report_type_sysname ===
                        "nps-score-per-service") &&
                      this.state.report_type_sysname !==
                        "percentage-surveys-returned" &&
                      this.state.reportListData &&
                      this.state.reportListData.length > 0 &&
                      this.state.reportListData.map((robj, ridx) => (
                        <tr key={ridx} className="table-updated-tr">
                          <React.Fragment key={`outer_` + ridx}>
                            {this.state.tableColumns &&
                              this.state.tableColumns.length > 0 &&
                              this.state.tableColumns.map((tobj, tidx) => {
                                let returnHtml = [];

                                if (tidx === 0) {
                                  returnHtml.push(
                                    <td
                                      key={ridx + `_` + tidx}
                                      className={"table-updated-td"}
                                    >
                                      {robj[tobj]}
                                    </td>,
                                  );
                                } else {
                                  let innerHTML = [];

                                  robj.inner_data &&
                                    robj.inner_data.length > 0 &&
                                    robj.inner_data.map((iobj, iidx) => {
                                      innerHTML.push(
                                        <div key={`inner_td_` + iidx}>
                                          {iobj[tobj]}
                                        </div>,
                                      );
                                    });

                                  returnHtml.push(
                                    <td
                                      key={ridx + `_` + tidx}
                                      className={"table-updated-td"}
                                    >
                                      {innerHTML}
                                    </td>,
                                  );
                                }
                                return (
                                  <React.Fragment key={`inner_` + tidx}>
                                    {returnHtml}
                                  </React.Fragment>
                                );
                              })}
                          </React.Fragment>
                        </tr>
                      ))}

                    {this.state.reportListData &&
                      this.state.reportListData.length <= 0 &&
                      this.state.showLoader === false &&
                      this.state.startFresh === false &&
                      this.state.report_type_sysname !==
                        "percentage-surveys-returned" && (
                        <tr className="table-updated-tr">
                          <td
                            className="table-updated-td no-record no-float"
                            colSpan={10}
                          >
                            {this.state.businessInsightLang.bi_no_record_found}
                          </td>
                        </tr>
                      )}
                  </tbody>
                </table>
              </div>

              <div
                className={
                  this.state.showLoadingText
                    ? "loading-please-wait no-margin-top"
                    : "loading-please-wait no-margin-top no-display"
                }
              >
                {this.state.globalLang.loading_please_wait_text}
              </div>
            </div>

            {this.state.report_type_sysname === "percentage-surveys-returned" &&
              this.state.grammar &&
              this.state.dataLoadedOnce && (
                <div className="sale-row">
                  <div className="salesStats">
                    <div className="dash-box business-stats">
                      <div className="inventry-title">
                        {this.state.reportData &&
                          this.state.reportData.total_survey_count}
                      </div>
                      <div className="dash-box-content">
                        {this.state.languageData.bi_sent}
                      </div>
                    </div>
                  </div>

                  <div className="salesStats">
                    <div className="dash-box business-stats">
                      <div className="inventry-title">
                        {this.state.reportData &&
                          this.state.reportData.submitted_percentage}
                      </div>
                      <div className="dash-box-content">
                        {this.state.languageData.bi_submitted}
                      </div>
                    </div>
                  </div>

                  <div className="salesStats">
                    <div className="dash-box business-stats">
                      <div className="inventry-title">
                        {this.state.reportData &&
                          this.state.reportData.satisfaction &&
                          this.state.reportData.satisfaction.high_satisfaction}
                      </div>
                      <div className="dash-box-content">
                        {this.state.languageData.bi_high_satisfaction}
                      </div>
                    </div>
                  </div>

                  <div className="salesStats">
                    <div className="dash-box business-stats">
                      <div className="inventry-title">
                        {this.state.reportData &&
                          this.state.reportData.satisfaction &&
                          this.state.reportData.satisfaction
                            .average_satisfaction}
                      </div>
                      <div className="dash-box-content">
                        {this.state.languageData.bi_avg_satisfaction}
                      </div>
                    </div>
                  </div>

                  <div className="salesStats">
                    <div className="dash-box business-stats">
                      <div className="inventry-title">
                        {this.state.reportData &&
                          this.state.reportData.satisfaction &&
                          this.state.reportData.satisfaction.low_satisfaction}
                      </div>
                      <div className="dash-box-content">
                        {this.state.languageData.bi_low_satisfaction}
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {this.state.report_type_sysname === "percentage-surveys-returned" &&
              this.state.grammar &&
              this.state.dataLoadedOnce && (
                <div className="row">
                  <div className="col-sm-4">
                    <div className="setting-setion m-b-15">
                      <div className="table-responsive">
                        <table className="table-updated sale-table no-td-border no-hover">
                          <thead className="table-updated-thead">
                            <tr>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_provider_name}
                              </th>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_score}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="ajax_body">
                            {this.state.reportData &&
                              this.state.reportData.provider_score &&
                              this.state.reportData.provider_score.map(
                                (obj, idx) => {
                                  return (
                                    <tr className="table-updated-tr" key={idx}>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_provider_name}
                                      </td>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_provider_score}
                                      </td>
                                    </tr>
                                  );
                                },
                              )}

                            {this.state.reportData &&
                              this.state.reportData.provider_score &&
                              this.state.reportData.provider_score.length ==
                                0 && (
                                <tr className="table-updated-tr">
                                  <td
                                    className="table-updated-td no-record no-float"
                                    colSpan={2}
                                  >
                                    {this.state.languageData.bi_no_record_found}
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4 memberProgram-right">
                    <div className="setting-setion m-b-15">
                      <div className="table-responsive">
                        <table className="table-updated sale-table no-td-border no-hover">
                          <thead className="table-updated-thead">
                            <tr>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_clinic_name}
                              </th>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_score}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="ajax_body">
                            {this.state.reportData &&
                              this.state.reportData.clinic_score &&
                              this.state.reportData.clinic_score.map(
                                (obj, idx) => {
                                  return (
                                    <tr className="table-updated-tr" key={idx}>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_clinic_name}
                                      </td>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_clinic_score}
                                      </td>
                                    </tr>
                                  );
                                },
                              )}

                            {this.state.reportData &&
                              this.state.reportData.clinic_score &&
                              this.state.reportData.clinic_score.length ==
                                0 && (
                                <tr className="table-updated-tr">
                                  <td
                                    className="table-updated-td no-record no-float"
                                    colSpan={2}
                                  >
                                    {this.state.languageData.bi_no_record_found}
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4 memberProgram-right">
                    <div className="setting-setion m-b-15">
                      <div className="table-responsive">
                        <table className="table-updated sale-table no-td-border no-hover">
                          <thead className="table-updated-thead">
                            <tr>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_service_name}
                              </th>
                              <th className="col-xs-6 table-updated-th">
                                {this.state.languageData.bi_score}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="ajax_body">
                            {this.state.reportData &&
                              this.state.reportData.service_score &&
                              this.state.reportData.service_score.map(
                                (obj, idx) => {
                                  return (
                                    <tr className="table-updated-tr" key={idx}>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_service_name}
                                      </td>
                                      <td className="col-xs-6 table-updated-td">
                                        {obj.bi_service_score}
                                      </td>
                                    </tr>
                                  );
                                },
                              )}

                            {this.state.reportData &&
                              this.state.reportData.service_score &&
                              this.state.reportData.service_score.length ==
                                0 && (
                                <tr className="table-updated-tr">
                                  <td
                                    className="table-updated-td no-record no-float"
                                    colSpan={2}
                                  >
                                    {this.state.languageData.bi_no_record_found}
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        <Loader showLoader={this.state.showLoader} isFullWidth={true} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  let returnState = {};
  const languageData = JSON.parse(localStorage.getItem("languageData"));

  if (state.BusinessInsightReducer.action === "GET_REPUTATION_REPORT") {
    if (state.BusinessInsightReducer.data.status != 200) {
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.BusinessInsightReducer.data.message],
      );
      returnState.showLoader = false;
    } else {
      returnState.reportOptionAndList = {
        savedReports: state.BusinessInsightReducer.reputationSavedReports,
        reportOptions: state.BusinessInsightReducer.repuationOptions,
        allData: state.BusinessInsightReducer.data.data,
      };
    }
  }

  if (state.BusinessInsightReducer.action === "GET_REPORT_VARIABLES") {
    if (state.BusinessInsightReducer.data.status !== 200) {
      returnState.showLoader = false;
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.BusinessInsightReducer.data.message],
      );
    } else {
      returnState.reportVariableData = state.BusinessInsightReducer.data.data;
    }
  }

  if (state.BusinessInsightReducer.action === "GET_REPORT_DATA") {
    if (state.BusinessInsightReducer.data.status != 200) {
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.BusinessInsightReducer.data.message],
      );
      returnState.showLoader = false;
    } else {
      returnState.reportData = state.BusinessInsightReducer.data.data;
    }
  }

  if (
    state.BusinessInsightReducer.action === "UPDATE_REPUTATION_SAVED_REPORTS"
  ) {
    if (state.BusinessInsightReducer.data.status != 200) {
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.BusinessInsightReducer.data.message],
      );
      returnState.showLoader = false;
    } else {
      uiNotification.clear();
      returnState.savedReports =
        state.BusinessInsightReducer.reputationSavedReports;
      returnState.redirect = true;
      returnState.message =
        languageData.global[state.BusinessInsightReducer.data.message];
    }
  }

  if (state.BusinessInsightReducer.action === "DOWNLOAD_REPORT_DATA") {
    if (state.BusinessInsightReducer.data.status != 200) {
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.BusinessInsightReducer.data.message],
      );
      returnState.showLoader = false;
    } else {
      returnState.downloadData = state.BusinessInsightReducer.data.data;
    }
  }

  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resetReducerAction: resetReducerAction,
      getOptionAndList: getOptionAndList,
      saveReport: saveReport,
      getReportVariables: getReportVariables,
      getReportData: getReportData,
      downloadReportData: downloadReportData,
      downloadSurveyData,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ReputationInsightReport));
